<template>
  <div>
    <div class="vx-card mb-4">
      <div class="vx-card__collapsible-content vs-con-loading__container">
        <div class="vx-card__body card-body">
          <div class="vx-row">
            <div class="vx-col w-full hide-in-print mb-4">
              <vs-button
                type="button"
                class="float-left mx-2 mb-2"
                style="background-color: #444"
                @click.prevent="backToCurrentGrid()"
                >{{ $t("Back") }}</vs-button
              >
            </div>
          </div>
          <div class="flex">
            <div class="w-full">
              <vs-button
                @click="showFilters = !showFilters"
                class="bg_purple float-right"
                ><div class="px-3">
                  <feather-icon
                    icon="FilterIcon"
                    svgClasses="h-4 w-4"
                    class="ico"
                  />
                  {{ $t("Filter") }}
                </div>
              </vs-button>
            </div>
          </div>
          <div class="vx-row px-4" v-if="showFilters">
            <div class="vx-col w-full">
              <form>
                <div class="vx-row flex items-end gap-4 justify-end">
                  <div class="flex-grow">
                    <div class="w-full">
                      <vs-input
                        class="inputx"
                        v-model="gridSearchData.keyword"
                        :label="$t('Search')"
                      />
                    </div>
                  </div>
                  <div class="flex justify-end gap-4">
                    <vs-button
                      type="filled"
                      class="float-right"
                      id="reset-btn"
                      @click.prevent="resetForm"
                      >{{ $t("ResetFilter") }}</vs-button
                    >
                    <vs-button
                      type="filled"
                      class="float-right"
                      @click.prevent="submitFilter()"
                      >{{ $t("SubmitFilter") }}</vs-button
                    >
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="vx-row pt-4">
            <div class="vx-col w-full mb-base">
              <data-grid
                ref="grid"
                stripe
                :data-source="gridDataSource"
                :search-data="gridSearchData"
                :columns="[
                  { title: $t('ProductName') },
                  { title: $t('ItemCode') },
                  { title: $t('BrandName') },
                  { title: $t('ProductSegment') },
                  { title: $t('Count') },
                  { title: $t('UnitPrice') },
                ]"
              >
                <template slot-scope="{ row }">
                  <td style="width: 30%">
                    {{ row.productName }}
                  </td>
                  <td style="width: 15%">
                    {{ row.itemCode }}
                  </td>
                  <td style="width: 15%">
                    {{ row.quotaTransactionItemBrandInfoQuery.brandName }}
                  </td>
                  <td style="width: 15%">
                    {{ row.segmentName }}
                  </td>
                  <td style="width: 10%">
                    {{ row.count }}
                  </td>
                  <td style="width: 12%">
                    <span class="price">{{
                      Number(row.price).toLocaleString()
                    }}</span>
                    <span>ریال</span>
                  </td>
                </template>
              </data-grid>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss" scoped>
#reset-btn {
  background: #3ec9d6 !important;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";
export default {
  name: "saleManagement_Quotas_Details",
  data() {
    return {
      gridDataSource: {
        type: "app",
        service:
          "/Sales/api/QuotaTransactionsQuery/" +
          this.$route.params.id +
          "/items",
      },
      gridSearchData: {},
      showFilters: false,
    };
  },
  methods: {
    submitFilter() {
      this.$refs.grid.renderGrid(1, true);
    },
    resetForm() {
      this.gridSearchData = {
        keyword: "",
      };
      setTimeout(() => {
        this.$refs.grid.renderGrid(1, true);
      }, 0);
    },
    backToCurrentGrid() {
      this.$router.push({
        path: "/Quotas/Index",
        query: {
          referencePageInfo: {
            tabIndex: this.$route.query.tabIndex,
            numberRowsPerPage: this.$route.query.numberRowsPerPage,
          },
        },
      });
    },
  },
  beforeRouteLeave(to, from, next) {
    if (to.path === "/Quotas/Index") {
      if (to.query.state) {
        delete to.query.state;
      }
      if (this.$route.query) {
        Object.assign(to.query, {
          quotaTransactionType: this.$route.query.quotaTransactionType,
        });
      }
      return next();
    } else {
      return next();
    }
  },
  components: {
    DataGrid,
  },
};
</script>
